import React, {
  useContext,
  useEffect,
  useState,
  useRef,
} from 'react'

import { ThemeContext } from 'styled-components'
import { useLenis } from '@studio-freight/react-lenis'
import { useRouter } from 'next/router'

import { GeneralContext } from 'contexts/General'
import { Responsive } from 'contexts/Responsive'

import {
  StyledLateralNavigation,
  StyledLateralNavigationButton
} from './styles'

const LateralNavigation = () => {
  const router = useRouter()
  const { checkBreakpoint } = useContext(ThemeContext)
  const { generalOptions } = useContext(GeneralContext)
  const lenis = useLenis()
  const [visible, setIsVisible] = useState(false)
  const [current, setCurrent] = useState(null)
  const [navTheme, setNavTheme] = useState('default')
  const footer = useRef(null)
  const sections = useRef(null)

  const {
    withNavigation,
    lateral
  } = generalOptions

  const updateHash = (hash) => {
    const pathAndSlug = router.asPath.split('#')[0]
    const newPath = `${pathAndSlug}#${hash}`

    window.location.replace(newPath)
  }


  const onNavigationUse = (item) => {
    const target = item['data-target']
    updateHash(target)
    const destination = `section[data-target="${target}"]`
    const scrollToEL = document.querySelector(destination)

    if (!scrollToEL) return

    setCurrent(target)

    lenis.scrollTo(scrollToEL, { offset: -100 })
    // TODO: WHYYY RERENDERS ALL
    // router.push(`#${evt.target.dataset.target}`, null, { shallow: true })
  }

  useEffect(() => {
    let ScrollTrigger


    const initTriggers = async () => {
      ScrollTrigger = (await import('gsap/dist/ScrollTrigger')).ScrollTrigger


      if (
        lateral &&
        !!lateral.length
      ) {
        footer.current = document.querySelector('#__next > footer')
        sections.current = document.querySelectorAll('[data-section]')

        const endTrigger = footer.current ? footer.current : sections.current[sections.current.length - 1]

        ScrollTrigger.create({
          trigger: sections.current[0],
          start: 'top center',
          endTrigger,
          end: 'top bottom',
          onToggle: self => setIsVisible(self.isActive)
        })

        lateral.map((item) => {
          const target = item['data-target']
          const element = document.querySelector(`section[data-target="${target}"]`)
          if (!element) return

          ScrollTrigger.create({
            trigger: element,
            start: 'top center',
            end: 'bottom center',
            onEnterBack: self => {
              if (!self.isActive) return
              setCurrent(target)
              // updateHash(target)
              setNavTheme(element.dataset.theme || 'default')
            },
            onEnter: self => {
              if (!self.isActive) return
              setCurrent(target)
              // updateHash(target)
              setNavTheme(element.dataset.theme || 'default')
            }
          })
        })
      }
    }

    initTriggers()

    return () => {
      if (ScrollTrigger) {
        const triggers = ScrollTrigger.getAll()
        triggers.forEach((trigger) => trigger.kill())
      }
    }
  }, [])

  if (!withNavigation) return <></>

  return (
    lateral &&
    !!lateral.length &&
    <Responsive on={checkBreakpoint.desktop}>
      <StyledLateralNavigation visible={visible} className={navTheme}>
        <ul>
          {
            lateral.map((item, idx) => (
              <li
                key={`LateralNavigation-${idx}-${item['data-target']}`}
              >
                <StyledLateralNavigationButton
                  {...item}
                  label={item['data-target']}
                  hideLabel
                  className={current === item['data-target'] ? 'current' : ''}
                  onClick={() => onNavigationUse(item)}
                />
              </li>
            ))
          }
        </ul>
      </StyledLateralNavigation>
    </Responsive>
  )
}

export default LateralNavigation
